import React from 'react';
import { ArrowRight, Search, Puzzle, Rocket } from 'lucide-react';
import { SectionProps, WithRefProps } from '../types';

interface HowItWorksSectionProps extends SectionProps, WithRefProps {
  handleCTAClick: (e: React.MouseEvent) => void;
}

const HowItWorksSection: React.FC<HowItWorksSectionProps> = ({ inView, forwardedRef, handleCTAClick }) => {
  return (
    <section id="how-it-works" className="section-padding bg-white">
      <div ref={forwardedRef} className={`container fade-up ${inView ? 'in-view' : ''}`}>
        <div className="text-center mb-16">
          <h2 className="mb-8">
            Ihr Weg zum Wunscharbeitgeber: In drei einfachen Schritten
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {/* Step 1 */}
          <div className="relative bg-white rounded-lg shadow-md p-8 transform hover:scale-[1.02] transition-all duration-300 border border-gray-100">
            <div className="absolute -top-4 -left-4 bg-primary-500 text-white w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold shadow-md">
              1
            </div>
            <div className="flex justify-center mb-6">
              <div className="bg-secondary-200 rounded-full p-4 inline-flex">
                <Search className="text-primary-500 w-8 h-8" />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-4 text-center">Kostenfreie Potentialanalyse</h3>
            <p className="text-center">
              Wir zeigen Ihnen, wie Sie die Zufriedenheit Ihrer Mitarbeiter steigern und gleichzeitig Kosten sparen können - ganz ohne Verpflichtung.
            </p>
          </div>
          
          {/* Step 2 */}
          <div className="relative bg-white rounded-lg shadow-md p-8 transform hover:scale-[1.02] transition-all duration-300 border border-gray-100">
            <div className="absolute -top-4 -left-4 bg-primary-500 text-white w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold shadow-md">
              2
            </div>
            <div className="flex justify-center mb-6">
              <div className="bg-secondary-200 rounded-full p-4 inline-flex">
                <Puzzle className="text-primary-500 w-8 h-8" />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-4 text-center">Maßgeschneiderter Benefits-Plan</h3>
            <p className="text-center">
              Gemeinsam entwickeln wir ein passgenaues Programm, das Ihr Team begeistert und Ihr Budget schont - mit maximaler staatlicher Unterstützung.
            </p>
          </div>
          
          {/* Step 3 */}
          <div className="relative bg-white rounded-lg shadow-md p-8 transform hover:scale-[1.02] transition-all duration-300 border border-gray-100">
            <div className="absolute -top-4 -left-4 bg-primary-500 text-white w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold shadow-md">
              3
            </div>
            <div className="flex justify-center mb-6">
              <div className="bg-secondary-200 rounded-full p-4 inline-flex">
                <Rocket className="text-primary-500 w-8 h-8" />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-4 text-center">Implementierung & Support</h3>
            <p className="text-center">
              Von der Einführung bis zum laufenden Betrieb - wir begleiten Sie Schritt für Schritt und sorgen dafür, dass Ihr Team die neuen Möglichkeiten optimal nutzt.
            </p>
          </div>
        </div>
        
        <div className="text-center mt-12">
          <a 
            href="#" 
            onClick={handleCTAClick}
            className="text-primary-500 font-medium hover:underline inline-flex items-center gap-2"
          >
            Starten Sie mit einer kostenfreien Analyse
            <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;